window.App ||= {}

# EXAMPLES
# generic case (success called manually)
#   lazyLoad = $(selector).lazyLoad(success: @render)
#   $.ajax({..., success: lazyLoad.success})
# backbone collection case (success reached when collection loads)
#   lazyLoad = $(selector).lazyLoad(success: @render).bindToCollection(collection)
# backbone view (not async)
#   view = new Monitoring.Views.MyView()
#   $('#content').lazyLoadView(view)

$.fn.extend
  lazyLoad: (callbacks) ->
    el = @
    new App.LazyLoadView({ el, callbacks }).start()
  lazyLoadView: (backboneView) ->
    backboneView.el = @.get(0)
    backboneView.$el.lazyLoad(success: backboneView.render).success()

class App.LazyLoadView extends Backbone.View
  templateEmpty:      JST["backbone/templates/app/lazy_load/empty"]
  templateProcessing: JST["backbone/templates/app/lazy_load/processing"]
  templateError:      JST["backbone/templates/app/lazy_load/error"]

  states:
    processing: 0
    success: 1
    error: 2

  initialize: (@options) ->
    super
    callbacks           = @options.callbacks
    @processingCallback = callbacks.processing
    @successCallback    = callbacks.success
    # @errorCallback      = callbacks.error

  render: (state = 0) ->
    @$el.html switch state
      when @states.processing
        @templateProcessing()
      when @states.success
        @templateEmpty()
      when @states.error
        @templateError()

  start: () =>
    @render(@states.processing)
    @_safeExecute(@processingCallback, @error)
    @

  success: =>
    @render(@states.success)
    @_safeExecute(@successCallback, @error)

  error: =>
    @render(@states.error)
    # @_safeExecute(@errorCallback)

  _safeExecute: (callbackFunction, onErrorFunction) ->
    try
      callbackFunction && callbackFunction.bind(@, arguments)()
    catch error

      errorHandler = new Monitoring.Methods.ErrorHandler(error)
      errorHandler.handle()
      onErrorFunction && onErrorFunction()
      false

  # helpers

  bindToCollection: (backboneCollection) ->
    # TODO bind error event
    backboneCollection.on('all', @success)
